import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { SharedPipesModule } from '@shared/pipes/shared-pipes.module';
import { ButtonModule } from 'primeng/button';
import { ProjectDiscussionAddCommentModule } from '../project-discussion-add-comment/project-discussion-add-comment.module';
import { ProjectDiscussionControlsComponent } from './components/project-discussion-controls/project-discussion-controls.component';

@NgModule({
    declarations: [],
    exports: [
        ProjectDiscussionControlsComponent,
    ],
    imports: [
        ButtonModule,
        CommonModule,
        FormsModule,
        NgSelectModule,
        ProjectDiscussionAddCommentModule,
        SharedPipesModule,
        ProjectDiscussionControlsComponent
    ]
})
export class ProjectDiscussionControlsModule { }
